import { IntimidateConfig } from 'game/extended/creatures/goblins/abilities/intimidate/intimidate'

export const intimidate_config: Array<IntimidateConfig> = [
    {
        available: 0,
        cooldown: 1,
        energy: 1,
        minimum_hp: 80
    }
]